import { router } from '@inertiajs/vue3'

export const reloadPropsFromServer = () => {
  router.reload()
}
